// <!-- GRACE:MODULE_START name="ui_auth" -->
// <!-- GRACE:DEPENDENCY target="ui_auth" -->
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface RegisterForm {
  email: string;
  password: string;
  confirmPassword: string;
  full_name: string;
}

// <!-- GRACE:CONTRACT function="RegisterPage" -->
export default function RegisterPage() {
  const { register: registerUser } = useAuth();
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, watch, formState: { errors } } = useForm<RegisterForm>();
  const password = watch('password');

  const onSubmit = async (data: RegisterForm) => {
    setError('');
    setMessage('');
    setLoading(true);
    try {
      const msg = await registerUser(data.email, data.password, data.full_name);
      setMessage(msg);
    } catch (e: any) {
      setError(e.message || 'Ошибка регистрации');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md rounded-2xl border bg-white p-8 shadow-sm">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-3 grid h-10 w-10 place-items-center rounded-xl bg-gray-900 text-sm font-bold text-white">
            VA
          </div>
          <h1 className="text-xl font-semibold">Регистрация</h1>
        </div>

        {message && (
          <div className="mb-4 rounded-lg bg-green-50 p-3 text-sm text-green-700">{message}</div>
        )}
        {error && (
          <div className="mb-4 rounded-lg bg-red-50 p-3 text-sm text-red-600">{error}</div>
        )}

        {!message && (
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <div>
              <label className="mb-1 block text-sm font-medium">Имя (необязательно)</label>
              <input
                type="text"
                className="w-full rounded-lg border px-3 py-2 text-sm focus:border-gray-400 focus:outline-none"
                placeholder="Иван Иванов"
                {...register('full_name')}
              />
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium">Email</label>
              <input
                type="email"
                className="w-full rounded-lg border px-3 py-2 text-sm focus:border-gray-400 focus:outline-none"
                placeholder="email@example.com"
                {...register('email', { required: 'Введите email' })}
              />
              {errors.email && <p className="mt-1 text-xs text-red-500">{errors.email.message}</p>}
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium">Пароль</label>
              <input
                type="password"
                className="w-full rounded-lg border px-3 py-2 text-sm focus:border-gray-400 focus:outline-none"
                placeholder="Минимум 8 символов"
                {...register('password', {
                  required: 'Введите пароль',
                  minLength: { value: 8, message: 'Минимум 8 символов' },
                })}
              />
              {errors.password && <p className="mt-1 text-xs text-red-500">{errors.password.message}</p>}
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium">Подтверждение пароля</label>
              <input
                type="password"
                className="w-full rounded-lg border px-3 py-2 text-sm focus:border-gray-400 focus:outline-none"
                placeholder="Повторите пароль"
                {...register('confirmPassword', {
                  required: 'Подтвердите пароль',
                  validate: (v) => v === password || 'Пароли не совпадают',
                })}
              />
              {errors.confirmPassword && <p className="mt-1 text-xs text-red-500">{errors.confirmPassword.message}</p>}
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full rounded-lg bg-gray-900 py-2.5 text-sm font-medium text-white hover:bg-gray-800 disabled:opacity-50"
            >
              {loading ? 'Регистрация...' : 'Зарегистрироваться'}
            </button>
          </form>
        )}

        <p className="mt-6 text-center text-sm text-gray-500">
          Уже есть аккаунт?{' '}
          <Link to="/login" className="font-medium text-gray-900 hover:underline">
            Войти
          </Link>
        </p>
      </div>
    </div>
  );
}
// <!-- GRACE:MODULE_END name="ui_auth" -->
